var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',{attrs:{"items":_vm.options,"label":_vm.label,"prepend-icon":"mdi-chevron-down-circle","clearable":"","chips":""},model:{value:(_vm.decision),callback:function ($$v) {_vm.decision=$$v},expression:"decision"}})}
var staticRenderFns = []

export { render, staticRenderFns }